// 显示后退按钮控件
export const showPageBack = 'showPageBack';

export const routerWillChange = 'routerWillChange';

export const routerHasChange = 'routerHasChange';

export const routerForward = 'routerForward';

export const routerBackward = 'routerBackward';

// 求职类型
export const jobType = [
  {
    value: '1',
    text: '全职（已毕业）',
  },
  {
    value: '2',
    text: '校招全职（应届生）',
  },
];

// 最高学历
export const education = [
  {
    value: '1',
    text: '本科',
  },
  {
    value: '2',
    text: '硕士',
  },
  {
    value: '3',
    text: '博士及以上',
  },
  {
    value: '4',
    text: '大专',
  },
];

// picker专用分隔显示符号
export const Separator = ' / ';

// 入职进度文案
export const personalInfoAuditEnum = [
  {
    text: '待完善',
    attr: '资料完善需上过专项培训过课后再填写，资料审核不通过将会影响发放',
  },
  {
    text: '待审核',
    attr: '',
  },
  {
    text: '审核通过',
    attr: '',
  },
  {
    text: '审核未通过',
    attr: '请登录客户端修改并重新提交个人介绍，资料审核不通过将会影响发放',
  },
];

// 入职进度 文案
export const entryInfoDataAuditEnum = [
  {
    text: '待完善',
    attr: '入职资料提交且审核通过后，工作人员才可安排合同签约',
    btnText: '去填写',
  },
  {
    text: '待审核',
    attr: '入职资料提交且审核通过后，工作人员才可安排合同签约',
    btnText: '去查看',
  },
  {
    text: '审核通过',
    attr: '入职资料提交且审核通过后，工作人员才可安排合同签约',
    btnText: '去查看',
  },
  {
    text: '审核未通过',
    attr: '入职资料提交且审核通过后，工作人员才可安排合同签约',
    btnText: '去修改 >',
  },
];

// 应用宝链接
export const applicationTreasureUrl =
  'https://android.myapp.com/myapp/detail.htm?apkName=com.zhangmen.teacher.am&ADTAG=mobile#fromopen';

// 入职进度 回收站判断字典
export const rejectCode = ['100', '200', '400', '600'];

// 入职进度 培训状态字典
export const courseStateEnum = [
  '<a style="display: inline-block; width: 100%; height: 100%; border: 1PX solid #EF4C4F; color: #EF4C4F;">未开始</a>',
  '<a style="display: inline-block; width: 100%; height: 100%; border: 1PX solid #58D26D; color: #58D26D;">进行中</a>',
  '<a style="display: inline-block; width: 100%; height: 100%; border: 1PX solid #999999; color: #999999;">已结束</a>',
];

// 招师代理银行列表
export const BANKLIST = [
  '中国工商银行',
  '中国农业银行',
  '中国银行',
  '中国建设银行',
  '交通银行',
  '中信银行',
  '中国光大银行',
  '华夏银行',
  '中国民生银行',
  '广发银行',
  '平安银行',
  '招商银行',
  '兴业银行',
  '浦发银行',
  '邮政储蓄银行',
];
function arrayToDict(arr) {
  return arr.map(item => {
    return {
      value: item,
      text: item,
    };
  });
}
export const BANKS = arrayToDict(BANKLIST);

// 招师代理 类型
export const AGENTTYPES = {
  FULLTIMEONE: 'full_time_1v1',
  PARTIMEONE: 'part_time_1v1',
  CHILD: 'child',
  TRAIN: 'train',
};

// 招师代理平台列表
export const ENVS = {
  app: 'app',
  pc: 'pc',
  wx: 'wx',
};

// 掌门教育用户注册协议及隐私政策
export const clause = 'https://static.zhangmen.com/protocol.html';

// 招师代理 加密
export const AesKey = '1234567890ABCDEF';
